import React from "react";
import { useAppSelector } from "src/store/store";
import { Text } from "@amzn/meridian";
import "./guidanceMessageOverlay.scss";

interface GuidanceMessageOverlayProps {
  raised?: boolean;
}

const GuidanceMessageOverlay: React.FC<GuidanceMessageOverlayProps> = ({ raised }) => {
  const { streamingGuidanceMessage } = useAppSelector((state) => state.inspectionCapture);

  if (!streamingGuidanceMessage) {
    return null;
  }

  return (
    <div className={raised ? "guidance-message-overlay guidance-message-overlay--raised" : "guidance-message-overlay"}>
      <Text color="inverted" type="b200" className="guidance-message-overlay__text">{streamingGuidanceMessage}</Text>
    </div>
  );
};

export default GuidanceMessageOverlay;
